<!--MODAL Bancolombia-->
<div class="modal fade hide" id="bancolombiaModal" tabindex="-1" role="dialog" aria-labelledby="bancolombiaModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog bancolombiaModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="container">
        <div class="row">
          <div class="col-6 img-bc-conecta d-none d-md-block"
            [style]="'background-image: url(assets/images/modals/img_modal_bancolombia_info.png);'">
          </div>
          <div class="col-12 img-bc-conecta d-block d-md-none"
            [style]="'background-image: url(assets/images/modals/img_modal_bancolombia_info_mobile.png);'">
            <button class="btn-close-mobile" (click)="close()" aria-label="Cerrar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="col-12 col-md-6 content-bc-connect">
            <button class="btn-close d-none d-md-block" (click)="close()">
              <span aria-hidden="true">&times;</span>
            </button>
            <app-recommendations-modal></app-recommendations-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>